// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"1290":"social-widget","1310":"message-pop-up","5802":"expanded-widget","8126":"minimized-widget","8445":"main-chat-widget"}[chunkId] + ".chunk.min.css";
};